import React from 'react';

import BeatLoader from 'react-spinners/BeatLoader';

const LoadingSpinner = (props) => (
   <div className={'text-center'}>
      <BeatLoader color={'#2489CC'} loading {...props} />
   </div>
);

export default LoadingSpinner;
